interface RobotWithLittleBoxSVGProps {
  color: string;
  style: React.CSSProperties;
}

const RobotWithLittleBoxSVG = ({
  color,
  style,
}: RobotWithLittleBoxSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="44"
    height="51"
    viewBox="0 0 44 51"
    fill="none"
  >
    <g clipPath="url(#clip0_519_19603)">
      <path
        d="M19.0022 11.7969H6.29808C4.04283 11.7969 2.2146 13.6251 2.2146 15.8804V21.9624C2.2146 24.2176 4.04283 26.0458 6.29808 26.0458H19.0022C21.2575 26.0458 23.0857 24.2176 23.0857 21.9624V15.8804C23.0857 13.6251 21.2575 11.7969 19.0022 11.7969Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M12.6501 26.0459V30.5615"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M0.604965 49.4882V36.1467C0.604965 33.1543 3.03561 30.7236 6.028 30.7236H19.2831C22.2755 30.7236 24.7061 33.1543 24.7061 36.1467V49.5638"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M16.1179 18.5705C16.1179 17.9764 16.604 17.4902 17.1981 17.4902C17.7923 17.4902 18.2784 17.9764 18.2784 18.5705"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M7.02187 18.5705C7.02187 17.9764 7.50799 17.4902 8.10215 17.4902C8.69631 17.4902 9.18244 17.9764 9.18244 18.5705"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M12.6501 11.7974V6.66602"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M15.4265 3.90029C15.4265 5.4343 14.1841 6.66582 12.6609 6.66582C11.1377 6.66582 9.89542 5.4235 9.89542 3.90029C9.89542 2.37709 11.1377 1.13477 12.6609 1.13477C14.1841 1.13477 15.4265 2.37709 15.4265 3.90029Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M6.30887 49.5309V40.4133C6.30887 39.3438 7.1731 38.4688 8.25338 38.4688H16.9713C18.0408 38.4688 18.9158 39.333 18.9158 40.4133V49.5741"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M29.3513 4.65556L36.3732 0.604492L43.395 4.65556L36.3732 8.71743"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.395 4.65527V12.7682L36.3732 16.8301L29.3513 12.7682V4.65527"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M36.3732 8.7168V14.1074"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M38.6958 28.7147L40.0786 26.8782C41.2669 25.301 41.699 23.4429 40.7268 21.7252L39.0955 18.8301"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.0506 28.7141L32.6678 26.8776C31.4795 25.3004 31.0474 23.4423 32.0197 21.7247L33.6941 18.7539"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.6953 36.1465H28.7032C29.3297 36.1465 29.8483 36.6542 29.8483 37.2916V40.8781C29.8483 41.5047 29.3405 42.0232 28.7032 42.0232H24.6953"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.8483 39.084H33.9966C35.3145 39.084 36.3732 38.0145 36.3732 36.7074V22.3828"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_519_19603">
        <rect width="44" height="50.1684" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default RobotWithLittleBoxSVG;
